import React from 'react'

import NavButton from './navButton'
import IconNext from '../../../../shared/components/icons/chevronRight'

import styles from './buttons.module.css'

const NextButton = ({ itemId }) => (
  <NavButton keyName="ArrowRight" itemId={itemId}>
    <IconNext className={styles.iconNext} />
  </NavButton>
)

export default NextButton
